import React from "react";
import twemoji from "twemoji";
import "./index.scss";

interface EmojiRendererProps {
  text: string;
}

const EmojiRenderer: React.FC<EmojiRendererProps> = ({ text }) => {
  const html = twemoji.parse(text, {
    folder: "svg",
    ext: ".svg",
    base: "https://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/",
  });

  return (
    <span
      className="emoji-renderer"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default EmojiRenderer;
